import { call, put, select, takeLatest } from 'redux-saga/effects';

import { format, parse } from 'date-fns';

import { addCustomGTMEvent } from '../../../events/googleTagManager';
import { formatError } from '../../../libs';
import customerAPI from '../../api/customer';
import { Creators, Types } from '../../reducers/customer';
import { getCartId, getLeadCookie } from '../../utils/cookies';
import { signInUser } from '../../utils/cookiesUser';
import getState from '../../utils/getState';

function* registerRequest({ user }) {
  try {
    const { customer, app } = yield select(getState);
    const cartId = customer.cartId || getCartId();
    const domain = app.getIn(['config', 'domain']);
    const siteId = app.getIn(['config', 'siteId']);
    const validUser = user;

    if (validUser.type.personType === 'PJ') {
      delete validUser.type.pf;
    } else {
      validUser.type.pf.birthday = format(parse(validUser.type.pf.birthday, 'dd/MM/yyyy', new Date()), 'yyyy-MM-dd');
      delete validUser.type.pj;
    }

    delete validUser.type.personType;

    // if (!isEmpty(validUser.document)) {
    //   Object.keys(validUser.document).forEach((key) => {
    //     validUser.document[key.replace('_', '')] = validUser.document[key];
    //     delete validUser.document[key];
    //   });
    // } else {
    //   delete validUser.document;
    // }

    if (cartId) validUser.account.cartId = cartId;

    const data = yield call(customerAPI.register, validUser, siteId);

    signInUser({ ...data, domain });

    try {
      yield call(customerAPI.deleteLeadByCartId, siteId, cartId);
    } catch (e) {
      console.log(e);
    }

    addCustomGTMEvent({
      event: 'sucess_signup',
      data: {
        customer_name: data.name,
      },
    });

    yield put(Creators.registerSuccess(data));
  } catch (error) {
    addCustomGTMEvent({
      event: 'fail_signup',
      data: {
        error: error?.message || '',
      },
    });
    console.log(error);
    yield put(Creators.registerFailed(formatError(error)));
  }
}

export default function* watch() {
  yield takeLatest(Types.REGISTER_REQUEST, registerRequest);
}
